import React from "react";
import PropTypes from 'prop-types';
import TextInfo, { TEXT_COLOR } from "@gc-npm/components.text";
import Image from "@gc-npm/components.c-image";
import Carousel from "@gc-npm/components.carousel";
import CustomLink from "@gc-npm/components.custom-link";
import { getFinalUrl } from "@gc-npm/utils.common.get-final-url";
import { useRouter } from "next/router";
import { SSR_DISPOSITIVOS_CONSTANTS } from "@gc-npm/utils.constants";
import Icon from "@gc-npm/components.icon-glyph";
const RecomsCarousel = (props) => {
  const router = useRouter();
  const { query } = router;
  const title = props["cms-atom-text-1"];
  const carouselItems = props["cms-ml-single-recom-1"];
  const { cmsHandler, cms, visible } = props;
  const contentVisible = visible === true || visible === "true";
  return (
    <>
      {cmsHandler && (
        <span
          className={"element-editable block"}
          onClick={cms && cmsHandler ?
            () => cmsHandler({
              ...props,
              name: 'cms-block.recoms-carousel'
            }) : null}
        >
          <Icon id="lapiz-m" height={15} color="white" />
        </span>
      )}
      {contentVisible && (
        <section
          className="recom-characterisctics container"
          data-cy="Section RecomCharacterisctics"
        >
          {title && (
            <TextInfo
              {...title}
              className="carousel-title"
              cmsHandler={cmsHandler}
            />
          )}
          {carouselItems && Array.isArray(carouselItems) && carouselItems.length > 0 && (
            <div
              className="recom-characterisctics--content"
              data-cy="RecomCharacterisctics Content"
            >
              <Carousel
                className={"recoms-carousel"}
                maxPointNum={0}
                breakpoint={768}
              >
                {carouselItems.map((item, index) => (
                  <div
                    className="recom-characterisctics--item"
                    key={`recom-characterisctics--${index}`}
                    data-cy="RecomCharacterisctics Card"
                  >
                    <div className="recom-characterisctics--item--image">
                      <Image
                        {...item["cms-atom-image-1"]}
                        objectFit="cover"
                        fill
                        cydata="RecomCharacteristics Image-1"
                        cmsHandler={cmsHandler}
                      />
                    </div>
                    <div className="recom-characterisctics--item--text">
                      <div className="recom-characterisctics--item--container-text">
                        {item["cms-atom-text-1"] && (
                          item["cms-atom-link-1"].href || cmsHandler ? (
                            <CustomLink
                              {...item["cms-atom-link-1"]}
                              href={getFinalUrl({
                                href: item["cms-atom-link-1"].href,
                                currentQueryParams: query,
                                queryParamsToKeep: SSR_DISPOSITIVOS_CONSTANTS.QUERY_PARAMS_TO_KEEP
                              })}
                              cmsHandler={cmsHandler}
                            >
                              <TextInfo
                                {...item["cms-atom-text-1"]}
                                className="recom-characterisctics--item--title"
                                cydata="RecomCharacteristics Text-1"
                                cmsHandler={cmsHandler}
                              />
                            </CustomLink>
                          ) : (
                            <TextInfo
                              {...item["cms-atom-text-1"]}
                              className="recom-characterisctics--item--title"
                              cydata="RecomCharacteristics Text-1"
                              cmsHandler={cmsHandler}
                            />
                          )
                        )}
                        {item["cms-atom-text-2"] && (
                          <TextInfo
                            text={item.description}
                            color={TEXT_COLOR.GREY5}
                            {...item["cms-atom-text-2"]}
                            className="recom-characterisctics--item--description"
                            cydata="RecomCharacteristics Text-2"
                            cmsHandler={cmsHandler}
                          />
                        )}
                      </div>

                      {item["cms-atom-text-3"] && (
                        <div className="recom-characterisctics--item--button">
                          <CustomLink
                            {...item["cms-atom-link-2"]}
                            href={getFinalUrl({
                              href: item["cms-atom-link-2"].href,
                              currentQueryParams: query,
                              queryParamsToKeep: SSR_DISPOSITIVOS_CONSTANTS.QUERY_PARAMS_TO_KEEP
                            })}
                            cmsHandler={cmsHandler}
                          >
                            <TextInfo
                              {...item["cms-atom-text-3"]}
                              className="recom-characterisctics--item--title"
                              cydata="RecomCharacteristics Text-3"
                              cmsHandler={cmsHandler}
                            />
                          </CustomLink>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          )}
        </section>
      )}
    </>
  );
};

RecomsCarousel.propTypes = {
  /**
   * {
   *  "info": "Visibilidad del bloque (con eliminación del DOM)",
   *  "kind": "both",
   *  "beautifulName": "Visibilidad del bloque"
   * }
   */
  visible: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

RecomsCarousel.defaultProps = {
  visible: true
};

export default RecomsCarousel;
